/**
 * User API — MOCK implementation.
 */

const MOCK_DELAY_MS = 500;
const delay = (ms) => new Promise((r) => setTimeout(r, ms));

let mockUser = null;

export async function signup(payload) {
  await delay(MOCK_DELAY_MS);
  mockUser = {
    id: 'mock-user-new',
    phone: payload.phone || '+989121111111',
    avatarUrl: null,
    createdAt: new Date().toISOString(),
    ...payload,
  };
  return mockUser;
}

export async function getProfile() {
  await delay(MOCK_DELAY_MS);
  if (!mockUser) {
    return {
      id: 'mock-user-1',
      phone: '+989909064164',
      firstName: 'علی',
      lastName: 'محمدی',
      age: 35,
      gender: 'male',
      address: 'تهران، خیابان ولیعصر',
      chronicDiseases: ['diabetes'],
      drugAllergies: [],
      foodAllergies: [],
      language: 'fa',
      avatarUrl: null,
      createdAt: '2024-01-15T10:00:00Z',
    };
  }
  return mockUser;
}

export async function updateProfile(updates) {
  await delay(MOCK_DELAY_MS);
  mockUser = { ...(mockUser || {}), ...updates };
  return mockUser;
}

const _reportSeen = new Set();
export async function getReport(analysisId) {
  await delay(MOCK_DELAY_MS);
  // First call → processing (demonstrates the wait screen), then ready.
  if (!_reportSeen.has(analysisId)) {
    _reportSeen.add(analysisId);
    return { status: 'processing' };
  }
  const html = `<!doctype html><html><head><meta charset="utf-8"><style>
    body{font-family:system-ui;margin:0;background:#f4efe7;color:#0f172a}
    .h{background:linear-gradient(135deg,#11223E,#2C4A78);color:#fff;padding:28px 32px}
    .h h1{margin:6px 0 0;font-size:22px}.c{padding:24px 32px}
    .card{background:#fff;border:1px solid #e6edf2;border-radius:14px;padding:18px;margin-bottom:14px}
    </style></head><body><div class="h"><div style="letter-spacing:3px;font-size:12px;opacity:.85">iBlink</div>
    <h1>Pre-Botox Facial Analysis</h1></div><div class="c">
    <div class="card"><b>Overall symmetry:</b> 86% · <b>Top dynamic zone:</b> Glabellar complex</div>
    <div class="card">This is a mock report preview. With the backend connected, your real
    analysis report renders here.</div></div></body></html>`;
  return { status: 'ready', html, summary: { overallSymmetry: 86 }, generatedAt: new Date().toISOString() };
}

async function getCredits() {
  await delay(MOCK_DELAY_MS);
  const now = Date.now();
  return [
    {
      agentKey: 'tern_plus',
      agentName: { en: 'Tern Plus Face Model (Botox)', fa: 'مدل چهره تِرن پلاس (بوتاکس)' },
      clinicCode: '123456',
      clinicName: { en: 'iBlink — Tehran', fa: 'iBlink — تهران' },
      available: 2,
      purchasedAt: new Date(now - 2 * 864e5).toISOString(),
      firstPurchasedAt: new Date(now - 9 * 864e5).toISOString(),
    },
    {
      agentKey: 'tern_plus',
      agentName: { en: 'Tern Plus Face Model (Botox)', fa: 'مدل چهره تِرن پلاس (بوتاکس)' },
      clinicCode: '654321',
      clinicName: { en: 'iBlink — Shiraz', fa: 'iBlink — شیراز' },
      available: 1,
      purchasedAt: new Date(now - 5 * 864e5).toISOString(),
      firstPurchasedAt: new Date(now - 5 * 864e5).toISOString(),
    },
  ];
}

// A pending request is the interesting state, so the mock starts with one:
// otherwise the approve/deny UI is unreachable offline.
let _physicianGrants = [
  { physicianPhone: '+989121111111', physicianName: 'دکتر سارا مرادی',
    title: { fa: 'متخصص پوست و مو', en: 'Dermatologist' }, avatarUrl: null,
    status: 'pending', reason: 'برای بررسی سابقه‌ی درمان‌های پیشین شما',
    requestedAt: new Date(Date.now() - 3600e3).toISOString(), grantedAt: null },
];

export async function listPhysicianAccess() {
  await delay(200);
  return _physicianGrants.filter((g) => g.status !== 'revoked');
}

export async function grantPhysicianAccess(physicianPhone) {
  await delay(280);
  const g = _physicianGrants.find((x) => x.physicianPhone === physicianPhone);
  if (g) { g.status = 'active'; g.grantedAt = new Date().toISOString(); }
  return { status: 'active' };
}

export async function revokePhysicianAccess(physicianPhone) {
  await delay(280);
  const g = _physicianGrants.find((x) => x.physicianPhone === physicianPhone);
  if (g) g.status = 'revoked';
  return { status: 'revoked' };
}

export const userApi = { listPhysicianAccess, grantPhysicianAccess, revokePhysicianAccess, signup, getProfile, updateProfile, getReport, getCredits, setConsent, getSharedClinics, grantClinic, revokeClinic , myNotes };
export default userApi;

export async function setConsent(dataConsent) {
  await new Promise((r) => setTimeout(r, 150));
  return { dataConsent };
}

let _shared = [{ code: '123456', name: 'iBlink (ولنجک)', grantedAt: new Date().toISOString() }];
export async function getSharedClinics() { await new Promise((r) => setTimeout(r, 150)); return [..._shared]; }
export async function grantClinic(clinicCode) { await new Promise((r) => setTimeout(r, 150)); const c = { code: clinicCode, name: 'کلینیک ' + clinicCode, grantedAt: new Date().toISOString() }; if (!_shared.some((x) => x.code === clinicCode)) _shared.push(c); return c; }
export async function revokeClinic(code) { await new Promise((r) => setTimeout(r, 120)); _shared = _shared.filter((x) => x.code !== code); return { revoked: true }; }


export async function myNotes() {
  await new Promise((r) => setTimeout(r, 150));
  return { notes: [
    { id: 'n1', title: 'مراقبت پس از درمان', body: 'تا ۴۸ ساعت از نور مستقیم آفتاب پرهیز کنید.', category: 'aftercare', clinicName: 'کلینیک رویا', createdAt: new Date(Date.now()-2*864e5).toISOString(), sharedWithClient: true },
  ] };
}
